
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen, BarChart, DollarSign } from 'lucide-react';
import { formatCurrency } from '@/utils/formatters';
import { RoyaltyReport } from '@/types';

interface QuarterSummaryCardProps {
  currentQuarterReports: RoyaltyReport[];
  totalSales: number;
  totalRoyaltyAmount: number;
  currency: string;
}

const QuarterSummaryCard: React.FC<QuarterSummaryCardProps> = ({
  currentQuarterReports,
  totalSales,
  totalRoyaltyAmount,
  currency
}) => {
  // Count unique book titles
  const uniqueBookTitles = new Set(
    currentQuarterReports
      .map(report => report.books?.title)
      .filter(title => title)
  );
  const bookCount = uniqueBookTitles.size;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Quarter Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="space-y-4">
          <div className="flex flex-row">
            <dt className="flex items-center gap-2 text-sm font-medium text-muted-foreground w-1/3">
              <BookOpen className="h-4 w-4" />
              Total Books
            </dt>
            <dd className="w-2/3 text-sm">{bookCount}</dd>
          </div>
          
          <div className="flex flex-row">
            <dt className="flex items-center gap-2 text-sm font-medium text-muted-foreground w-1/3">
              <BarChart className="h-4 w-4" />
              Total Units Sold
            </dt>
            <dd className="w-2/3 text-sm">{totalSales.toLocaleString()}</dd>
          </div>
          
          <div className="flex flex-row">
            <dt className="flex items-center gap-2 text-sm font-medium text-muted-foreground w-1/3">
              <DollarSign className="h-4 w-4" />
              Total Amount
            </dt>
            <dd className="w-2/3 text-sm font-medium text-lg">{formatCurrency(totalRoyaltyAmount)} {currency}</dd>
          </div>
        </dl>
      </CardContent>
    </Card>
  );
};

export default QuarterSummaryCard;
